import { secondaryFontFamily } from '@openeducation/oe-it-themes';
import React, { ReactNode } from 'react';
import { View } from 'react-native';

import OpenEnglishLogo from '../../atoms/logos/open-english-logo';
import { OEText } from '../../atoms/oe-text/oe-text';
import { flex, mt } from '../../style-utils';

export interface PanelLoginHeaderProps {
  title?: string;
  logo?: ReactNode;
}

export const LoginHeader = ({ title, logo }: PanelLoginHeaderProps) => {
  return (
    <View style={flex('align-items-center')}>
      {logo || <OpenEnglishLogo />}
      <OEText
        fontFamily={secondaryFontFamily}
        fontType="bold"
        fontSize={20}
        style={mt(16)}
      >
        {title}
      </OEText>
    </View>
  );
};

export default LoginHeader;
